// extracted by mini-css-extract-plugin
export default {"profileContainer":"exam-menu-screen_profileContainer__A56dP","content":"exam-menu-screen_content__kMtbq","tips":"exam-menu-screen_tips__e5XQ5"};